import { render, staticRenderFns } from "./PopManualBox.vue?vue&type=template&id=2501f596&scoped=true"
import script from "./PopManualBox.vue?vue&type=script&lang=js"
export * from "./PopManualBox.vue?vue&type=script&lang=js"
import style0 from "./PopManualBox.vue?vue&type=style&index=0&id=2501f596&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2501f596",
  null
  
)

export default component.exports